<template>
  <div>
    <LoadingModal :show="loading" :label="loadingLabel" :overlay="true" />
    <h1 class="u-m0">
      <span class="u-screenreader">
        Претрага по Називу медија
      </span>
    </h1>
    <form action="">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Претрага по називу медија</legend>
        <div class="grid">
          <div class="grid-cell u-full u-xmed-1of3 fieldset-item">
            <label for="media-name" class="fieldset-label">Mедији по кључној речи</label>
            <input type="text" v-model="mediaKeyword" placeholder="Унесите текст за претрагу" class="input_reg" />

          </div>
          <div class="grid-cell u-full u-xmed-1of2 fieldset-item">
            <label for="media-name" class="fieldset-label">Назив медија (Можете изабрати више медија)</label>
            <VueSelect v-model="selectedMedia" label="media_name" :options="media" multiple>
              <template v-slot:no-options>Нема резултата за унету претрагу!</template>
            </VueSelect>
          </div>
          <div class="grid-cell u-full u-xlarge-auto fieldset-item"></div>
          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-from" class="fieldset-label">Датум од</label>
            <VueDatePicker v-model="date.from" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'"
              :enable-time-picker="false" :auto-apply="true" locale="sr" placeholder="Од датума"
              input-class-name="input" />
          </div>

          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-to" class="fieldset-label">Датум до</label>

            <VueDatePicker v-model="date.to" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'"
              :enable-time-picker="false" :auto-apply="true" locale="sr" placeholder="До датума"
              input-class-name="input" />
          </div>

          <div class="grid-cell u-full u-xmed-auto fieldset-item fieldset-item--noLabel">
            <button @click.stop.prevent="submit" class="button button--fieldset">Тражи</button>
          </div>
        </div>
      </fieldset>
    </form>

    <div v-if="data && data.length > 0" class="results">
      <h2 class="h2">Резултати претраге:</h2>
      <p class="fieldset-label">Укупан број одобрених пројеката: <span>{{ data.length }}</span></p>
      <p class="fieldset-label u-mb40">Укупан износ предвиђених средстава: <span>{{ fundsSum }}</span> дин</p>

      <div class="table-wrap">
        <table class="table sticky-header">
          <thead>
            <tr class="table-row">
              <td class="table-cell" @click="sortBy('township')" style="cursor:pointer;">
                Општина/Град
                <span :class="['sort-indicator', sortKey === 'township' && 'sort-indicator--active']">{{ sortKey === 'township' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
              </td>
              <td class="table-cell" @click="sortBy('submitterName')" style="cursor:pointer;">
                Подносилац пројекта
                <span :class="['sort-indicator', sortKey === 'submitterName' && 'sort-indicator--active']">{{ sortKey === 'submitterName' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
              </td>
              <td class="table-cell" @click="sortBy('name')" style="cursor:pointer;">
                Назив пројекта
                <span :class="['sort-indicator', sortKey === 'name' && 'sort-indicator--active']">{{ sortKey === 'name' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
              </td>
              <td class="table-cell" @click="sortBy('date')" style="cursor:pointer;">
                Датум
                <span :class="['sort-indicator', sortKey === 'date' && 'sort-indicator--active']">{{ sortKey === 'date' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
              </td>
              <td class="table-cell">
                Изабрани чланови комисије
              </td>
              <td class="table-cell" @click="sortBy('funds')" style="cursor:pointer;">
                Износ предвиђених средстава
                <span :class="['sort-indicator', sortKey === 'funds' && 'sort-indicator--active']">{{ sortKey === 'funds' ? (sortOrder === 'asc' ? '▲' : '▼') : '↕' }}</span>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="project in sortedData" :key="project.id" class="table-row">
              <td class="table-cell">
                <router-link :to="`/konkurs/${project.contestId}#t`" target="_blank" rel="noopener">
                  {{ project.township }}
                </router-link>
              </td>
              <td class="table-cell">
                <span v-if="project.submitter">{{ project.submitter.name }}</span>
              </td>
              <td class="table-cell">{{ project.name }}</td>
              <td class="table-cell">{{ project.date }}.</td>
              <td class="table-cell">
                <ul>
                  <li v-for="member in project.commissionMembers.filter(m => m && m.chosen)" :key="member.id">
                    {{ member.member_name }}
                  </li>
                </ul>
              </td>
              <td class="table-cell">{{ `${project.funds.toLocaleString('sr')} RSD` }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script src="./Media.js"></script>
<style scoped>
.input_reg {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: var(--radius);
}
</style>